import React, { Fragment } from "react"
const Footer = props => {
  return (
    <Fragment>
      <p>
       <span className="text-info">PIL ANDINA S.A. © Copyright </span> {new Date().getFullYear()} All Rights
        Reserved.
      </p>
    </Fragment>
  )
}
export default Footer
